import { render, staticRenderFns } from "./dashboard-inbound.vue?vue&type=template&id=0fe20bf6"
import script from "./dashboard-inbound.vue?vue&type=script&lang=js"
export * from "./dashboard-inbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports